import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("oz_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const WHATSAPP_NUMBER = "905079240826";
export const PHONE_DISPLAY = "+90 507 924 08 26";
export const EMAIL = "info@ozkayalarinsaat.com";
export const INSTAGRAM_HANDLE = "ozkayalarinsaat35";
export const INSTAGRAM_URL = "https://instagram.com/ozkayalarinsaat35";
export const WHATSAPP_LINK = (msg = "Merhaba, projeleriniz hakkında bilgi almak istiyorum.", number) =>
  `https://wa.me/${number || WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
